import { IconInfoCircleFilled } from '@tabler/icons-react';
import clsx from 'clsx';

const BAlert = ({ title, children, color = 'default', hidden = false }) => {
  const colors = {
    error: 'border-red-300 bg-red-50 text-red-800 ',
    success: 'border-green-300 bg-green-50 text-green-800',
    default: 'border-primary-300 bg-primary-50 text-primary-800',
    warning: 'border-yellow-300 bg-yellow-50 text-yellow-800',
  };
  if (hidden) {
    return;
  }
  return (
    <div id="alert-additional-content-2" className={clsx('rounded-lg border p-4', colors[color] ?? '')} role="alert">
      <div className="flex items-center" hidden={!title}>
        <IconInfoCircleFilled className="me-2 h-4 w-4 shrink-0" />
        <span className="sr-only">Info</span>
        <h3 className="text-md font-medium">{title}</h3>
      </div>
      <div className="text-sm">{children}</div>
    </div>
  );
};

export default BAlert;
